































import { filterMixin } from '@/utils/mixins/filterMixin'
import Autocomplete from '@/components/Autocomplete.vue'
import { getAgencies } from '@/api/Agency/agency.api'
import { Services } from '@/utils/interfaces'
import { getServices } from '@/api/Services/services.api'
import UserListItem from '@/components/UserListItem.vue'
import FlatFilter from '~/components/FlatFilter.vue'

export default filterMixin.extend({
  components: {
    appAutocomplete: Autocomplete,
    appUsersListItem: UserListItem,
    FlatFilter,
  },
  data() {
    return {
      getAgencies: getAgencies,
      services: [] as Services[],
      loading: {
        services: false,
      },
    }
  },
  async mounted() {
    try {
      this.loading.services = true
      const response = await getServices()
      this.services = response.data.results.filter(service => service.active)
      if (!this.$store.getters.profile.is_superuser) {
        this.services = this.services.filter(service =>
          this.$store.getters.profile.services.includes(service.name),
        )
      }
    } finally {
      this.loading.services = false
    }
  },
})
